// import { Bell, HelpingHand, Moon, Settings, Sun, SunMoon } from "lucide-react";
// import React from "react";
// import * as motion from "motion/react-client";
// import logo from "../../assets/logo.png";
//
// export const Nav = () => {
//
//     return (<>
//         <nav style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
//             <div style={{ display: "flex", alignItems: "center", gap: "10px", margin: "10px"}}>
//                 <motion.img src={logo} alt="logo" height={30} />
//                 <motion.span>OnMostDays</motion.span>
//             </div>
//             <div style={{ display: "flex", gap: "20px", margin: "10px" }}>
//                 <Bell style={{ border: "2px solid white", padding: "5px", borderRadius: "50%" }}/>
//                 <HelpingHand style={{ border: "2px solid white", padding: "5px", borderRadius: "50%" }} />
//                 <Settings style={{ border: "2px solid white", padding: "5px", borderRadius: "50%" }} />
//                 {/* DARK MODE BUTTONS */}
//                 {/*<Sun style={{ border: "2px solid white", padding: "5px", borderRadius: "50%" }}/>*/}
//                 {/*<Moon style={{ border: "2px solid white", padding: "5px", borderRadius: "50%" }}/>*/}
//                 {/*<SunMoon style={{ border: "2px solid white", padding: "5px", borderRadius: "50%" }}/>*/}
//             </div>
//         </nav>
//     </>)
// }

import * as motion from "motion/react-client";
import logo from "../../assets/logo.png";
import { Bell, HelpCircle, Settings } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/Button";

export const Nav = ({
                        children,
                    }: Readonly<{
    children: React.ReactNode;
}>) => {
    const navigate = useNavigate();
    const [theme, setTheme] = useState<string>();
    // const [daysOrNightsText, setDaysOrNightsText] = useState<string>();

    useEffect(() => {
        // if (UserSession.ready) {
        //     console.log("UserSession", UserSession.session)
        //     setDarkMode(UserSession.session?.darkMode)
        // }
    }, [/*UserSession.ready*/]);

    const setDarkMode = (mode: "light" | "dark" | "auto" | undefined ) => {
        console.log("mode", mode)
        if (mode === "auto") {
            const time = new Date().getHours();
            if (time >= 6 && time <= 18) {
                setTheme("light");
                // setDaysOrNightsText("Days");
            } else {
                setTheme("dark");
                // setDaysOrNightsText("Nights");
            }
        } else {
            setTheme(mode);
            // setDaysOrNightsText(mode === "light" ? "Days" : "Nights");
        }
        // UserSession.saveSession({
        //     darkMode: mode,
        // })
    }


    return <div className={`min-h-screen w-full flex flex-col items-center justify-between transition-colors duration-500`}>
        <nav className="flex items-center justify-between w-full p-4">
            {/*<h1 className="text-2xl font-extrabold flex items-center">*/}
            {/*    <ThemeToggle theme={theme === "light" ? "light" : theme === "dark" ? "dark" : "light"} />*/}
            {/*</h1>*/}
            <div className="flex gap-4 items-center">
                <motion.img src={logo} alt="logo" width={30} onClick={() => navigate("/")} />
                <motion.span>OnMostDays</motion.span>
            </div>
            <div className="flex items-center gap-4">
                <Button variant="ghost"><Bell /></Button>
                <Button variant="ghost"><HelpCircle /></Button>
                <Button variant="ghost"><Settings /></Button>
            </div>
        </nav>
        {children}
        <footer className="m-4 text-sm opacity-75">
            © 2025 OnMostDays. All rights reserved.
        </footer>
    </div>
}